import { Form, Theme } from 'piconetworks/customization-serializer'

export const themeSerializer = (id) => {
    return new Theme(id)
}

export const formSerializer = (id) => {
    return new Form(id)
}
